// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Reports_wrapper__3oXK2","tabs":"Reports_tabs__25f1V","tabContent":"Reports_tabContent__3Z2BM"};